import {
  getTicket
} from '@/api/api'
import store from '@/store'
import router, {
  resetRouter
} from '@/router/index'
export default {
  data() {
    return {
      local: 'http://192.168.0.105:',
      developLocal: 'http://192.168.0.241:',
      localIp: 105,
      developIp: 241
    }
  },
  methods: {
    // 获取192时 登录成功后返回的地址
    getLocal(queryHref) {
      // 返回开发地址
      if (queryHref.includes(this.developIp)) {
        return this.developLocal
      } else if (queryHref.includes(this.localIp)) {
        // 返回本地服务地址
        return this.local
      }
    },

    // 微信登录对应的数据返回
    getIsWxLogin() {
      const code = this.getUrlKey('code')
      if (code) {
        // 微信登录时 返回缓存的跳回地址
        return localStorage.getItem('originalWebsite')
      } else {
        return null
      }
    },

    // 二维码返回的code/state字段
    getUrlKey(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [,
        ''
      ])[1].replace(/\+/g, '%20')) || null
    },

    // 获取左侧展示数据
    getWebsiteData(queryHref) {
      let arr = [{
        bigUrl: require('@/assets/imgs/big/icon_serviceStation_b@2x.png'),
        smallUrl: require('@/assets/imgs/small/icon_serviceStation_s@2x.png'),
        name: '五十三线上服务站',
        hrefPage: 'serviceStation',
        link: this.switchServiceStationWebsiteLink(queryHref)
      }, {
        bigUrl: require('@/assets/imgs/big/icon_tracking_b@2x.png'),
        smallUrl: require('@/assets/imgs/small/icon_tracking_s@2x.png'),
        name: '项目追踪',
        hrefPage: 'tracking',
        link: this.switchTrackingWebsiteLink(queryHref)
      }, {
        bigUrl: require('@/assets/imgs/big/icon_chatgpt_b@2x.png'),
        smallUrl: require('@/assets/imgs/small/icon_chatgpt_s@2x.png'),
        name: '创新平台GPT',
        hrefPage: 'chatgpt',
        link: this.switchChatgptWebsiteLink(queryHref)
      }, {
        bigUrl: require('@/assets/imgs/big/icon_53ofc_b@2x.png'),
        smallUrl: require('@/assets/imgs/small/icon_53ofc_s@2x.png'),
        name: '云联智办OA',
        hrefPage: 'service',
        link: this.switchServiceWebsiteLink(queryHref)
      }]

      // 根据环境变化赋值体验版数据demo
      let customArr = []
      if (queryHref.includes('https') || queryHref.includes('dev')) {
        customArr = [{
          bigUrl: require('@/assets/imgs/big/icon_53ofc_demo_b@2x.png'),
          smallUrl: require('@/assets/imgs/small/icon_53ofc_demo_s@2x.png'),
          name: '云联智办OA(体验)',
          hrefPage: 'service',
          link: this.switchServiceDemoWebsiteLink(queryHref)
        }]
      }

      let arrSec = [{
        bigUrl: require('@/assets/imgs/big/icon_official_b@2x.png'),
        smallUrl: require('@/assets/imgs/small/icon_official_s@2x.png'),
        name: '五十三科技官网',
        hrefPage: 'official',
        link: this.switchOfficialWebsiteLink(queryHref)
      }]

      return arr.concat(customArr).concat(arrSec)
    },

    // 不选择平台时 默认跳转官网地址
    switchOfficialWebsiteLink(queryHref) {
      let str = ''

      // 微信登录时
      if (this.getIsWxLogin()) {
        str = this.getIsWxLogin()
      } else {
        // 账号登录
        if (queryHref.includes('https')) {
          str = 'https://www.53tech.cn'
        } else if (queryHref.includes('dev')) {
          str = 'http://dev.www.53tech.cn'
        } else if (queryHref.includes('192.')) {
          str = this.getLocal(queryHref) + '8081'
        }
      }

      console.log(str, 'switchOfficialWebsiteLink')
      return str
    },

    // chatgpt地址
    switchChatgptWebsiteLink(queryHref) {
      let str = ''

      // 微信登录时
      if (this.getIsWxLogin()) {
        str = this.getIsWxLogin()
      } else {
        // 账号登录
        if (queryHref.includes('https')) {
          if (window.innerWidth < 500) {
            // 移动端
            str = 'https://m.chatgpt.53tech.cn'
          } else {
            // PC
            str = 'https://chatgpt.53tech.cn'
          }
        } else if (queryHref.includes('dev')) {
          if (window.innerWidth < 500) {
            // 移动端
            str = 'http://dev.m.chatgpt.53tech.cn'
          } else {
            // PC
            str = 'http://dev.chatgpt.53tech.cn'
          }
        } else if (queryHref.includes('192.')) {
          if (window.innerWidth < 500) {
            // 移动端
            str = this.getLocal(queryHref) + '8085'
          } else {
            // PC
            str = this.getLocal(queryHref) + '8082'
          }
        }
      }

      console.log(str, 'switchChatgptWebsiteLink')
      return str
    },

    // 云联智办地址
    switchServiceWebsiteLink(queryHref) {
      let str = ''

      // 微信登录时
      if (this.getIsWxLogin()) {
        str = this.getIsWxLogin()
      } else {
        // 账号登录
        if (queryHref.includes('https')) {
          str = 'https://www.53ofc.cn'
        } else if (queryHref.includes('dev')) {
          str = 'http://dev.service.53tech.cn'
        } else if (queryHref.includes('192.')) {
          str = this.getLocal(queryHref) + '8084'
        }
      }

      console.log(str, 'switchServiceWebsiteLink')
      return str
    },

    // 云联智办-体验版
    switchServiceDemoWebsiteLink(queryHref) {
      let str = ''

      // 微信登录时
      if (this.getIsWxLogin()) {
        str = this.getIsWxLogin()
      } else {
        // 账号登录
        if (queryHref.includes('https')) {
          str = 'https://demo.53ofc.cn'
        } else if (queryHref.includes('dev')) {
          str = 'http://dev.demo.service.53tech.cn'
        }
      }

      console.log(str, 'switchServiceDemoWebsiteLink')
      return str
    },

    // 项目追踪地址
    switchTrackingWebsiteLink(queryHref) {
      let str = ''

      // 微信登录时
      if (this.getIsWxLogin()) {
        str = this.getIsWxLogin()
      } else {
        // 账号登录
        if (queryHref.includes('https')) {
          str = 'https://www.53track.cn'
        } else if (queryHref.includes('dev')) {
          str = 'http://dev.www.53track.cn'
        } else if (queryHref.includes('192.')) {
          str = this.getLocal(queryHref) + '8083'
        }
      }

      console.log(str, 'switchTrackingWebsiteLink')
      return str
    },

    // 线上服务站地址
    switchServiceStationWebsiteLink(queryHref) {
      let str = ''

      // 微信登录时
      if (this.getIsWxLogin()) {
        str = this.getIsWxLogin()
      } else {
        if (queryHref.includes('https')) {
          str = 'https://service.station.53tech.cn'
        } else if (queryHref.includes('dev')) {
          str = 'http://dev.service.station.53tech.cn'
        } else if (queryHref.includes('192.')) {
          str = this.getLocal(queryHref) + '8086'
        }
      }

      console.log(str, 'switchServiceStationWebsiteLink')
      return str
    },

    // 获取swiperOption默认数据
    getSwiperOption() {
      return {
        // 初始化相关
        init: true, // 初始化swiper
        initialSlide: 0, // 初始显示slide的索引

        // 方向与尺寸
        // direction: 'horizontal', // 滑动方向: 'horizontal' | 'vertical'
        // width: null, // 强制设置宽度
        // height: null, // 强制设置高度
        // autoHeight: false, // 自动高度

        loop: true, // 循环模式 (解决键盘按下闪烁的问题)

        // 滑动效果(fade 渐变)
        effect: 'fade', // 切换效果: 'slide' | 'fade' | 'cube' | 'coverflow' | 'flip' | 'creative' | 'cards'
        speed: 800, // 切换速度(ms)
        fadeEffect: {
          crossFade: true // 交叉淡入淡出
        },

        // 自动播放
        autoplay: {
          // 这个参数很重要,当外力干扰轮播图时，它能够继续实现自我滚动
          disableOnInteraction: false, // 用户操作后是否继续自动播放
          delay: 3000 // 延迟时间 5s
        },

        // 懒加载
        // lazy: {
        //   loadPrevNext: false, // 加载前后slide
        //   loadPrevNextAmount: 1, // 加载前后数量
        //   // loadOnTransitionStart: false, // 切换开始时加载
        //   // elementClass: 'swiper-lazy', // 懒加载元素类
        //   // loadingClass: 'swiper-lazy-loading', // 加载中类
        //   // loadedClass: 'swiper-lazy-loaded', // 已加载类
        //   // preloaderClass: 'swiper-lazy-preloader' // 预加载器类
        // },

        // 键盘控制(禁用不必要的交互)
        keyboard: {
          enabled: false, // 启用键盘
          pageUpDown: false, // 支持PageUp/PageDown
        },

        // 防止触摸干扰
        simulateTouch: false,
        allowTouchMove: false,

        // 观察变化
        observer: true,
        observeParents: true,
        observeSlideChildren: true,

        // 预加载
        preloadImages: true,
        updateOnImagesReady: true,

        // 回调函数
        on: {
          init: function() {
            console.log('Swiper initialized');
          },
          transitionStart: function() {
            console.log('Transition started');
          },
          transitionEnd: function() {
            console.log('Transition ended');
          }
        }
      }
    },

    // 获取系统名称
    switchSystemName(system) {
      let str = ''
      switch (system) {
        case 'official':
          str = '科技时代'
          break;
        case 'tracking':
          str = '项目追踪'
          break;
        case 'service':
          str = '科技时代' // 运维中心
          break;
        case 'serviceStation':
          str = '科技时代' // 线上服务站
          break;
      }
      return '五十三' + str
    },

    // 重置登录状态
    resetLogin() {
      // localStorage.removeItem('ticket')
      // localStorage.removeItem('token')
      // sessionStorage.removeItem('ticket')
      // sessionStorage.removeItem('token')
      // localStorage.removeItem('logon')
      // 登录失效
      store.commit('SET_LOGIN', null)
      // 20241225 新增注释
      // resetRouter()
      // router.push({
      //   path: '/'
      // })
    },

    // 获取上午、下午、晚上状态
    getTimeState() {
      // 获取当前时间
      let timeNow = new Date();
      // 获取当前小时
      let hours = timeNow.getHours();
      // 设置默认文字
      let state = ``;
      // 判断当前时间段
      if (hours >= 0 && hours <= 11) {
        state = `上午`;
      } else if (hours > 11 && hours <= 13) {
        state = `中午`;
      } else if (hours > 13 && hours <= 18) {
        state = `下午`;
      } else if (hours > 18 && hours <= 24) {
        state = `晚上`;
      }
      return state + '好';
    },

    // 设置保持登录有效期
    setLocalExpire(key, expire) {
      if (!expire || Number(expire) === 0) {
        localStorage.removeItem(key)
      } else {
        // 86400000一天时间的毫秒数
        let time = expire * 1000 * 60 * 60 * 24
        let obj = {
          time: Date.now(), //存值时间戳
          expire: Date.now() + time, //过期时间
        }
        // 注意，localStorage不能直接存储对象类型，sessionStorage也一样
        // 需要先用JSON.stringify()将其转换成字符串，取值时再通过JSON.parse()转换回来
        console.log(key, JSON.stringify(obj), 'setLocalExpire')
        localStorage.setItem(key, JSON.stringify(obj))
      }
    },

    // // 获取保持登录有效期
    // getLocalExpire(key, type, noJump, code) {
    //   alert(noJump)
    //   let val = localStorage.getItem(key)
    //   // 如果没有值就直接返回null
    //   if (!val) return val
    //   // 存的时候转换成了字符串，现在转回来
    //   val = JSON.parse(val)
    //   // 存值时间戳 + 有效时间 = 过期时间戳
    //   // 如果当前时间戳大于过期时间戳说明过期了，删除值并返回提示
    //   if (Date.now() > val.expire) {
    //     localStorage.removeItem(key)
    //     // localStorage.removeItem('ticket')
    //     // sessionStorage.removeItem('ticket')
    //     // localStorage.removeItem('token')
    //     // sessionStorage.removeItem('token')
    //   } else {
    //     if (type) {
    //       setTimeout(() => {
    //         // 获取公共tickt  跳转回原网站
    //         this.getTicket(localStorage.getItem('originalWebsite'), localStorage.getItem('hrefPage'), localStorage
    //           .getItem('logon'), noJump, code)
    //       }, 50)
    //     }
    //   }
    // },

    // 获取公共tickt
    getTicket(originalWebsite, businessName, logon, noJump, code, fourZOne) {
      console.log(localStorage.getItem('token'), logon, 'token logon')
      let token // 统一登录token
      // 20240229新增
      token = localStorage.getItem('token')
      // 20241204 新增 如果是退出登录跳转 则不调用getTicket接口来获取ticket
      let isLogout = localStorage.getItem('isLogout') || ''
      // if (logon != 0) {
      //   token = localStorage.getItem('token')
      // } else {
      //   token = sessionStorage.getItem('token')
      // }
      if (token && !isLogout) {
        // chatgpt/official/运维中心service/项目追踪tracking
        // 20241212 新增字段 如果401 并且是登录保护时 不会返回ticket来进行跳转*
        getTicket({
          businessName,
          fourZOne: fourZOne ? 1 : null // 1表示401进入，其他表示正常
        }).then(res => {
          if (res.code === 200) {
            // 20240229新增 有ticket后跳转  20240510新增（同一账号时 ticket不变 => 获取的缓存ticket）
            // 返回有值 则代表已登录可以跳转
            // 20240510新增 res.data获取最新的ticket （ticket过期后后端给返回的） 20250106 新增登录保护401返回为空
            this.ticketJump(originalWebsite, businessName, logon, noJump, code, res.data || '', token)
          } else {
            // 20240229 新增没有值代表已退出登录 // 20250106 新增注释 此方式仅代表单个平台的退出登录 => 不清缓存
            // localStorage.removeItem('ticket')
            console.log(res.msg, 'res.msg')
            // // 重置登录状态
            // this.resetLogin()
            // 20250106 新增错误提示
            // this.$message.error(res.msg)
          }
        }).catch(err => {
          // 20240229 新增没有值代表已退出登录  // 20250106 新增注释 此方式仅代表单个平台的退出登录 => 不清缓存
          // localStorage.removeItem('ticket')
          console.log(err, 'err')
          // // 重置登录状态
          // this.resetLogin()
          // 20250106 新增错误提示
          // this.$message.error(err)
        })
      }
    },

    // 有ticket后跳转
    ticketJump(originalWebsite, businessName, logon, noJump, code, ticketData, token) {
      let ticket = null // 口令
      // let loginToken // 公共token

      // 20240229注释
      // let logonExpire = localStorage.getItem('logonExpire') ? JSON.parse(localStorage.getItem('logonExpire'))
      //   .expire : ''
      // if (logon) {
      //   // 保持登录时一直缓存ticket 直至过期
      //   sessionStorage.removeItem('ticket')
      //   localStorage.setItem('ticket', ticketData)
      //   logonExpire = localStorage.getItem('logonExpire') ? JSON.parse(localStorage.getItem('logonExpire'))
      //     .expire : ''
      //   // loginToken = localStorage.getItem('token')
      // } else {
      //   // 无保持登录时 浏览器关闭后删除ticket
      //   sessionStorage.setItem('ticket', ticketData)
      //   localStorage.removeItem('ticket')
      //   logonExpire = ''
      //   // loginToken = sessionStorage.getItem('token')
      // }
      console.log(originalWebsite, ticket, ticketData, 'originalWebsite ticket, ticketData')
      // 20240229 新增
      if (ticketData) {
        localStorage.setItem('ticket', ticketData)
        console.log(localStorage.getItem('ticket'), 'ticketData setItem')
      }

      // 非微信绑定时 不是运维中心-新注册用户时
      if (localStorage.getItem('ticket') && !code && !(businessName === 'service' && !ticketData)) {
        ticket = localStorage.getItem('ticket')
        console.log(ticket, localStorage.getItem('ticket'), 'ticket getItem')
      }

      // 20240229注释 || sessionStorage.getItem('ticket')
      console.log(ticket, noJump, 'ticket noJump')
      // 其他登录注册等场景 微信绑定/运维中心-新注册用户时(*20251126 此功能无 已在注册后跳转步骤进行拦截)
      if ((ticket && !noJump) || code || (businessName === 'service' && !ticketData)) {
        console.log(ticket, token, originalWebsite, 'ticket, token originalWebsite')
        // return
        // 跳转回之前系统  微信绑定时无ticket/token
        window.location.href = originalWebsite + '?token=' + ticket + '&loginToken=' + token +
          '&logon=' + null + '&code=' + (code || '')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/commonMethods.js